import { styled } from '@mui/material';

export const Content = styled('div')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  boxShadow: '0px 4px 4px 0px #00000040',
  width: '441px',
  height: '156px',
  background: '#FFFFFF',
  padding: 26,
  display: 'grid',
  gridTemplateColumns: 'auto 1fr',
  gap: '10px 10px',
  alignItems: 'center',
  h3: {
    margin: '0 0 5px 0',
    padding: 0,
    fontWeight: 400,
    fontSize: 14,
  },
  h2: {
    margin: 0,
    padding: 0,
    fontWeight: 400,
    fontSize: 20
  }
});

export const Stripe = styled('div')({
  height: '1px',
  width: '100%',
  background: 'linear-gradient(90deg, #DB1F26 0%, #2881BE 29.5%, #227D3E 65.5%, #F5A61D 100%)',
  gridColumn: '1 / 3'
});
